import { DataModel } from "common/models/utility-models/base-model";
import { Time } from "highcharts";

export class AssignmentModel extends DataModel {
    override id:any = '';
    topic: string = '';
    description: string = '';
    type_id: any = null;
    location: any = null;
    category: any = null;
    trainer: any = null;
    emailID: string = '';
    trigger_email: any = '';
    show_trainer_details: any = '';
    batch_id: any = null;
    branch_id: any = [];
    group_id: any = [];
    student_ids: any = [];
    // timeline: any = ''
    time: Time | any = [];
    uploadAssignment: any = '';
    addDescription: string = '';
    upload_document: any = '';
    backDateAssignmentFlag: any = '';
    batch: any;
    student_id: any;
    isSelected: any;
    travelReimbursementFlag: boolean = false;
    travelDocUploadStartDate: any = '';
    travelDocUploadEndDate: any = '';
    travelEmailDoc: any = null;
    east: string = '';
    west: string = '';
    north: string = '';
    south: string = '';
    assignmentDoc: any = '';
  }